export function PageWrapper({ children }: { children: React.ReactNode }) {
  return (
    <div className="">
      <div className="w-screen h-screen max-w-xl mx-auto">
        <div className="px-5 py-6">{children}</div>
      </div>
    </div>
  );
}
